export default "__VITE_ASSET__DcbCKnj6__"